/** Figma Dashboard / Kintsugi Advisor — neutral and layout tokens (node 10933:72139). */
/**
 * Kin Chatbot — assistant reply fill (Figma [13101-69655](https://www.figma.com/design/bYyIivHby22hQ1jTAxVnHV/Kin-Chatbot?node-id=13101-69655); same swatch as legacy node 13101-70068).
 */
export const ADVISOR_ASSISTANT_BUBBLE_BG = "#F4F5F7";
/**
 * Legacy soft shadow — the Kin AI Answer plate in Figma (13101:69655) is flat (no drop shadow). Prefer no shadow on ``AdvisorAssistantMarkdown``.
 */
export const ADVISOR_ASSISTANT_BUBBLE_BOX_SHADOW =
  "0 2px 8px rgba(23, 24, 24, 0.05), 0 4px 14px rgba(23, 24, 24, 0.04)";
/**
 * Kin Chatbot — user message bubble fill, Figma Primary/700 (KG) ([User question — 13101-70065](https://www.figma.com/design/bYyIivHby22hQ1jTAxVnHV/Kin-Chatbot?node-id=13101-70065)).
 */
export const ADVISOR_USER_BUBBLE_BG = "#213331";
export const ADVISOR_PANEL_NEUTRAL_100 = "#E7E7E7";
export const ADVISOR_PANEL_NEUTRAL_200 = "#D1D1D1";
export const ADVISOR_PANEL_NEUTRAL_400 = "#3D3D3D";
export const ADVISOR_PANEL_NEUTRAL_250 = "#888888";
export const ADVISOR_PANEL_NEUTRAL_50_BG = "#F6F6F6";
export const ADVISOR_PANEL_PRIMARY_500 = "#396862";
/** KDS primary.600 — hover shade for inline links in assistant markdown. */
export const ADVISOR_PANEL_PRIMARY_600 = "#2A4542";
export const ADVISOR_PANEL_PRIMARY_50 = "#F4F9F8";
/**
 * Soft Kin mint — lead thinking-dot + active tool-progress glyph.
 * Matches the AI answering accent used beside the Kin avatar (not Primary/500).
 */
export const ADVISOR_KIN_MINT_400 = "#8BBDB3";
/** Softer mint steps for the three thinking dots (after {@link ADVISOR_KIN_MINT_400}). */
export const ADVISOR_KIN_MINT_200 = "#B7D8D1";
export const ADVISOR_KIN_MINT_100 = "#DBECE7";
/** Matches agent ``ChatFeedbackV2Request.comment`` max_length (kintsugi-agent). */
export const ADVISOR_MESSAGE_FEEDBACK_COMMENT_MAX_LENGTH = 2000;
/**
 * Figma “Popup Shadow” — RHS drawer chrome and the **inline thumbs-down written-feedback card**
 * (Kin “Not helpful”, frame `13191:23818`). Use via `AgentAssistantWrittenFeedbackInline` only — do not fork the shadow string in app shells.
 */
export const ADVISOR_PANEL_BOX_SHADOW =
  "0 8px 32px -4px rgba(23, 24, 24, 0.12), 0 -2px 26px -3px rgba(23, 24, 24, 0.08)";
